import React from "react";
import { IconButton } from "@material-ui/core";
import CallMadeIcon from '@material-ui/icons/CallMade';
import LicenceModel from "../../../models/LicenceModel";
import useNavigator from "../../../hooks/navigator.hook";


const LicenceIconLink = ({ licence }: { licence?: LicenceModel | null }) => {
  const { navigateToLicencePage } = useNavigator();

  if (!licence) {
    return null;
  }

  const onOpen = () => {
    navigateToLicencePage({ licenceId: licence.id, locationId: licence.locationId });
  }

  return (
    <IconButton
      aria-label='licence'
      color='secondary'
      size='small'
      onClick={onOpen}
    >
      <CallMadeIcon />
    </IconButton>
  )
}

export default LicenceIconLink;